/* drehmer-package-cart.js (PDP v11, framed-bundle template only)
   Framed, gallery wrap or custom size: Add to Cart puts ONE line in the cart. The line is a hidden
   "package" product built by the bundler service (painting + frame as a fixed Shopify bundle, with a
   picture of the framed painting). Unframed standard sizes never reach this file's code path.

   Reads the selection through window.drehmerPackageState() (defined in main-product-bundle.liquid, 3c).
   Failures before cart/add (service URL, network error, timeout, price mismatch) use the old flow:
   product-form.js adds painting + frame as two lines. A cart/add failure never retries the add. */
(function () {
  'use strict';
  if (window.__drehmerPackageCart) return;
  window.__drehmerPackageCart = true;

  /* Service base URL. window.DREHMER_PACKAGE_URL overrides it (tests). Empty = old flow. */
  var SERVICE_URL = 'https://pdp-bundler-production.up.railway.app';
  var CLICK_TIMEOUT_MS = 10000;
  /* the cart is already open and looks final, so a slow new package can be waited for instead of falling to two lines */
  var OPEN_CART_WAIT_MS = 30000;
  var PREWARM_TIMEOUT_MS = 30000;
  var PREWARM_DEBOUNCE_MS = 650;
  var PREWARM_CUSTOM_QUIET_MS = 1500;
  var SLOW_COPY_MS = 3000;

  var log = window.__drehmerPackageLog = [];
  function note(ev, data) {
    var e = { t: Date.now(), ev: ev };
    if (data) e.data = data;
    log.push(e);
    if (log.length > 60) log.shift();
  }

  function serviceUrl() {
    var u = (typeof window.DREHMER_PACKAGE_URL === 'string') ? window.DREHMER_PACKAGE_URL : SERVICE_URL;
    return String(u || '').replace(/\/+$/, '');
  }
  function readState() {
    try { return typeof window.drehmerPackageState === 'function' ? window.drehmerPackageState() : null; }
    catch (e) { return null; }
  }
  /* package only for a frame, a gallery wrap or a custom size; never in "request this size" mode */
  function needsPackage(s) {
    if (!s || s.request || !s.productId) return false;
    if (s.custom) return !!(s.custom.w_in > 0 && s.custom.h_in > 0);
    return (s.format === 'framed' || s.format === 'stretched') && !!s.frameVariantId && !!s.variantId;
  }
  function payloadOf(s, prewarm) {
    var p = {
      product_id: Number(s.productId),
      variant_id: s.custom ? null : Number(s.variantId),
      frame_variant_id: (s.format === 'framed' || s.format === 'stretched') && s.frameVariantId ? Number(s.frameVariantId) : null,
      custom: s.custom ? { w_in: s.custom.w_in, h_in: s.custom.h_in } : null,
      prewarm: !!prewarm
    };
    /* Catalog frame: the variant is only the price source (same price for every style in a band);
       the style travels as its slug. Never on Gallery Wrap. */
    if (s.format === 'framed' && s.frame && s.frame.slug) p.frame_style = s.frame.slug;
    return p;
  }
  function keyOf(p) {
    return [p.product_id, p.variant_id || 'c', p.frame_variant_id || 'u', p.custom ? (p.custom.w_in + 'x' + p.custom.h_in) : '', p.frame_style || ''].join('|');
  }

  /* ---------- service calls (one in flight per selection; the click reuses the prewarm) ---------- */
  var cache = {};
  function callService(p, timeoutMs) {
    var url = serviceUrl();
    if (!url) return Promise.reject(new Error('no service url'));
    var ctrl = (typeof AbortController === 'function') ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctrl) ctrl.abort(); }, timeoutMs);
    return fetch(url + '/bundle', {
      method: 'POST',
      mode: 'cors',
      credentials: 'omit',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(p),
      signal: ctrl ? ctrl.signal : undefined
    }).then(function (r) {
      if (!r.ok) throw new Error('bundle http ' + r.status);
      return r.json();
    }).then(function (d) {
      clearTimeout(timer);
      return d;
    }, function (e) {
      clearTimeout(timer);
      throw e;
    });
  }
  function usable(d) { return !!(d && d.variant_id && d.price != null); }
  /* the package's framed picture, loaded as soon as the package is known, so the cart line can show it at once;
     the same picture the cart line uses (Shopify's copy at 140 px, or the service render while Shopify processes it) */
  var RENDER_BASE = 'https://pdp-bundler.apps.art-and-see.com';
  var thumbs = {}, thumbWanted = null;
  function thumbOf(k, d) {
    var src = d && (d.image || (d.key ? RENDER_BASE + '/render/' + d.key + '.jpg' : ''));
    if (!src) return null;
    /* Shopify's copy at the address the cart line asks for (image_url: width: 140), so the line finds it already loaded */
    var m = /^https?:\/\/cdn\.shopify\.com\/s\/files\/[^?]*\/files\/([^?]+)(\?v=\d+)?/.exec(src);
    if (m) src = location.origin + '/cdn/shop/files/' + m[1] + (m[2] || '') + (m[2] ? '&' : '?') + 'width=140';
    var t = thumbs[k];
    if (!t || t.getAttribute('data-src') !== src) { t = new Image(); t.decoding = 'async'; t.setAttribute('data-src', src); t.src = src; thumbs[k] = t; }
    if (thumbWanted && thumbWanted.k === k) thumbWanted.use(t);
    return t;
  }
  function ensurePackage(p, timeoutMs) {
    var k = keyOf(p);
    var c = cache[k];
    if (c && c.result) return Promise.resolve(c.result);
    if (c && c.promise) return c.promise;
    var pr = callService(p, timeoutMs).then(function (d) {
      if (usable(d)) { cache[k] = { result: d }; thumbOf(k, d); }
      else delete cache[k];
      return d;
    }, function (e) {
      delete cache[k];
      throw e;
    });
    cache[k] = { promise: pr };
    return pr;
  }
  function withTimeout(promise, ms) {
    return new Promise(function (resolve, reject) {
      var t = setTimeout(function () { reject(new Error('timeout')); }, ms);
      promise.then(function (v) { clearTimeout(t); resolve(v); }, function (e) { clearTimeout(t); reject(e); });
    });
  }

  /* ---------- prewarm: the package exists before the click ---------- */
  var prewarmTimer = null, lastPrewarmKey = '', lastChangeAt = 0;
  function schedulePrewarm(delay) {
    clearTimeout(prewarmTimer);
    prewarmTimer = setTimeout(function () {
      var s = readState();
      if (!needsPackage(s) || !serviceUrl()) return;
      /* a custom size is typed: wait for a longer pause, so half-typed sizes never become packages */
      var quiet = Date.now() - lastChangeAt;
      if (s.custom && quiet < PREWARM_CUSTOM_QUIET_MS) { schedulePrewarm(PREWARM_CUSTOM_QUIET_MS - quiet); return; }
      var p = payloadOf(s, true);
      var k = keyOf(p);
      if (k === lastPrewarmKey && cache[k]) return;
      lastPrewarmKey = k;
      note('prewarm', k);
      /* the service draws the framed picture from the choice alone, so it loads while the package is still being made */
      var rk = renderKey(p);
      if (rk && !thumbs[k]) thumbOf(k, { key: rk });
      ensurePackage(p, PREWARM_TIMEOUT_MS).then(function (d) {
        note('prewarm-ok', { k: k, v: d && d.variant_id, created: d && d.created });
      }, function (e) {
        note('prewarm-fail', { k: k, err: String(e && e.message || e) });
        if (lastPrewarmKey === k) lastPrewarmKey = '';
      });
    }, delay || PREWARM_DEBOUNCE_MS);
  }
  ['click', 'change', 'input'].forEach(function (type) {
    document.addEventListener(type, function (ev) {
      var t = ev.target;
      if (!t || !t.closest || !t.closest('.drehmer')) return;
      /* the add buttons themselves are not a change of selection */
      if (t.closest('product-form, [data-drehmer-sticky], .floating-checkout')) return;
      lastChangeAt = Date.now();
      schedulePrewarm();
    }, { passive: true });
  });

  /* ---------- button state: short, calm copy while the package is prepared ---------- */
  (function injectStyle() {
    if (document.getElementById('drehmer-pkg-style')) return;
    var st = document.createElement('style');
    st.id = 'drehmer-pkg-style';
    st.textContent =
      '.drehmer__pkg-note{display:none}' +
      '.drehmer__add-btn.drehmer-pkg-busy{opacity:1!important;cursor:progress}' +
      '.drehmer__add-btn.drehmer-pkg-busy [data-drehmer-btn-normal],.drehmer__add-btn.drehmer-pkg-busy [data-drehmer-btn-enter]{display:none!important}' +
      '.drehmer-pkg-busy .loading-overlay__spinner{display:none!important}' +
      '.drehmer__add-btn.drehmer-pkg-busy .drehmer__pkg-note{display:inline;animation:drehmer-pkg-breathe 1.8s ease-in-out infinite}' +
      '.drehmer__sticky-btn.drehmer-pkg-busy{opacity:1!important;cursor:progress}' +
      '.drehmer__sticky-btn.drehmer-pkg-busy .drehmer__pkg-note{display:flex;position:absolute;inset:0;align-items:center;justify-content:center;animation:drehmer-pkg-breathe 1.8s ease-in-out infinite}' +
      '@keyframes drehmer-pkg-breathe{0%,100%{opacity:1}50%{opacity:.62}}' +
      '@media (prefers-reduced-motion:reduce){.drehmer-pkg-busy .drehmer__pkg-note{animation:none!important}}';
    (document.head || document.documentElement).appendChild(st);
  })();
  function buttons() {
    return {
      main: document.querySelector('[data-drehmer-add-btn]'),
      sticky: document.querySelector('[data-drehmer-sticky-add]')
    };
  }
  function noteEl(btn) {
    var n = btn.querySelector('.drehmer__pkg-note');
    if (!n) {
      n = document.createElement('span');
      n.className = 'drehmer__pkg-note';
      n.setAttribute('aria-hidden', 'true');
      btn.appendChild(n);
    }
    return n;
  }
  var slowTimer = null;
  function setBusy(on) {
    var b = buttons();
    clearTimeout(slowTimer);
    [b.main, b.sticky].forEach(function (btn) {
      if (!btn) return;
      if (on) noteEl(btn).textContent = 'Adding to cart…';
      btn.classList.toggle('drehmer-pkg-busy', on);
      if (on) btn.setAttribute('aria-busy', 'true'); else btn.removeAttribute('aria-busy');
    });
    /* .loading on the main button: the section mirrors it onto the sticky bar and the mobile
       floating bar, and its CSS turns off pointer events (no second click) */
    if (b.main) b.main.classList.toggle('loading', on);
    if (on) {
      slowTimer = setTimeout(function () {
        [b.main, b.sticky].forEach(function (btn) { if (btn) noteEl(btn).textContent = 'Almost ready…'; });
      }, SLOW_COPY_MS);
    }
  }

  /* ---------- the add ---------- */
  /* What the customer reads is the site name the card showed ("Classic Ornate"); the service's
     frame_label is the same name from the same catalog. The supplier code ("Frame 7 · Grace") only
     goes in the hidden _frame_code. Old Shopify-variant cards keep their own name. */
  function frameText(s, d) {
    if (s.frame && s.frame.site) return s.frame.site;
    if (d && typeof d.frame_label === 'string' && d.frame_label) return d.frame_label;
    return s.frameName || 'Custom frame';
  }
  function frameCode(s, d) {
    if (s.frame && s.frame.code) return s.frame.code;
    var m = String((d && (d.frame_code || d.frame_style)) || '').match(/Frame\s+\d+(\s*\u00b7\s*[^\u2014]+?)?(?=\s*\u2014|$)/);
    return m ? m[0].trim() : '';
  }
  function lineProperties(s, d, k) {
    var props = {};
    if (s.custom) props['Custom size'] = s.sizeText;
    else props['Painting size'] = s.sizeText;
    if (s.format === 'framed') {
      props['Frame'] = frameText(s, d);
      props['Made to fit'] = s.fitText;
      if (s.frame) props['_frame_code'] = frameCode(s, d);
    } else if (s.format === 'stretched') {
      props['Frame'] = 'Gallery wrap';
      props['Made to fit'] = s.fitText;
    }
    props['_package_key'] = String((d && (d.key || d.package_key)) || k);
    if (s.productUrl) props['_product'] = s.productUrl;
    /* the cart drawer treats any line whose properties contain "ID" as the old two-line bundle */
    Object.keys(props).forEach(function (name) {
      if (props[name] == null || props[name] === '') { delete props[name]; return; }
      props[name] = String(props[name]).replace(/ID/g, 'Id');
    });
    return props;
  }
  function cartAdd(pf, d, s, k) {
    var cart = pf.cart || document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var fd = new FormData();
    fd.append('id', String(d.variant_id));
    fd.append('quantity', String(s.quantity || 1));
    var props = lineProperties(s, d, k);
    Object.keys(props).forEach(function (name) { fd.append('properties[' + name + ']', props[name]); });
    if (cart && typeof cart.getSectionsToRender === 'function') {
      fd.append('sections', cart.getSectionsToRender().map(function (x) { return x.id; }));
      fd.append('sections_url', window.location.pathname + window.location.search);
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
    }
    var config = (typeof fetchConfig === 'function') ? fetchConfig('javascript') : { method: 'POST', headers: { 'Accept': 'application/javascript' } };
    config.headers = config.headers || {};
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = fd;
    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
    function attempt(retried) {
      return fetch(addUrl, config).then(function (r) {
        if (r.status === 429 && !retried) {
          var wait = Math.min(8, parseFloat(r.headers.get('Retry-After')) || 2.5) * 1000;
          note('cart-add-429', wait);
          return new Promise(function (res) { setTimeout(res, wait); }).then(function () { return attempt(true); });
        }
        return r;
      });
    }
    return attempt(false).then(function (r) {
      if (!r.ok) throw new Error('cart add http ' + r.status);
      return r.json();
    }).then(function (res) {
      if (!res || res.status) throw new Error('cart add ' + (res && (res.description || res.message) || 'error'));
      return { res: res, cart: cart };
    });
  }
  /* same steps product-form.js runs after a normal add */
  function showCart(pf, out, variantId) {
    var cart = out.cart, res = out.res;
    try {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: variantId });
      }
    } catch (e) {}
    if (!cart) { window.location = (window.routes && window.routes.cart_url) || '/cart'; return; }
    function renderCart() {
      return Promise.resolve().then(function () { return cart.renderContents(res); }).catch(function (error) {
        note('render-fail', String(error && error.message || error));
        if (typeof pf.handleErrorMessage === 'function') pf.handleErrorMessage('Your item was added, but the cart could not be displayed. Please open your cart to check it.');
      });
    }
    try {
      var quickAddModal = pf.closest('quick-add-modal');
      if (quickAddModal) {
        document.body.addEventListener('modalClosed', function () { setTimeout(renderCart); }, { once: true });
        quickAddModal.hide(true);
      } else {
        return renderCart();
      }
    } catch (e) { note('render-fail', String(e && e.message || e)); }
  }

  /* v14: a custom size whose price has no helper variant can only be carted as a package. If the service fails,
     the two-line flow would add the form's stale variant, so the shopper gets a short note by the button instead. */
  function cartNote(s) {
    var wrap = document.querySelector('.drehmer .drehmer__add-btn-wrap');
    if (!wrap) return;
    var n = document.querySelector('[data-drehmer-cart-note]');
    if (!n) {
      n = document.createElement('p');
      n.className = 'drehmer-bundle__cart-note';
      n.setAttribute('data-drehmer-cart-note', '');
      n.setAttribute('role', 'alert');
      n.style.cssText = 'margin:10px 0 0;font-size:13px;line-height:1.45;color:#b42318;text-align:center';
      wrap.parentNode.insertBefore(n, wrap.nextSibling);
    }
    n.innerHTML = 'We couldn’t add this size just now. Please try again in a moment' +
      (s && s.requestUrl ? ', or <a href="' + s.requestUrl + '" style="color:inherit;text-decoration:underline">send us the size</a> and we’ll reply by email.' : '.');
  }
  document.addEventListener('input', function (ev) {
    var n = document.querySelector('[data-drehmer-cart-note]');
    if (n && ev.target && ev.target.closest && ev.target.closest('.drehmer')) n.remove();
  }, true);

  /* ---------- the cart opens on the click, already looking final ----------
     The line the customer chose appears at once (framed render, name, frame, size, price) and the subtotal includes
     it; Shopify's confirmation happens underneath and the real cart replaces it without a visible change. Checkout
     clicked before the confirmation simply waits for it. If the page is left first, the next page finishes the add
     (sessionStorage), never twice: a line with the same package key already in the cart counts as done. */
  var PENDING_KEY = 'drehmer-pending-add';
  var MINUS = '<svg class="icon icon-minus" width="14" height="3" viewBox="0 0 14 3" fill="none"><path d="M6 0.5H8H14V2.5H8H6H0V0.5H6Z" fill="currentColor"/></svg>';
  var PLUS = '<svg class="icon icon-plus" width="14" height="15" viewBox="0 0 14 15" fill="none"><path d="M6 6.5V0.5H8V6.5H14V8.5H8V14.5H6V8.5H0V6.5H6Z" fill="currentColor"/></svg>';
  var CARET = '<svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 20 20"><path d="M9.99996 11.6667L6.66663 8.33333H13.3333L9.99996 11.6667Z" fill="currentColor"/></svg>';

  var leaving = false;
  window.addEventListener('pagehide', function () { leaving = true; });
  window.addEventListener('beforeunload', function () { leaving = true; });
  var pendingDone = null, resolvePending = null;
  (function injectPendingStyle() {
    if (document.getElementById('drehmer-pending-style')) return;
    var st = document.createElement('style');
    st.id = 'drehmer-pending-style';
    st.textContent =
      '.drehmer-pending__status{display:none;font-size:13px;color:#b42318;margin:8px 0 0}' +
      '.drehmer-pending--failed .drehmer-pending__status{display:block}' +
      /* the theme's cart-remove-button look (component-cart-drawer.css), without the element that would act on a real line */
      '.drehmer-pending__remove{margin-left:auto}' +
      '.drehmer-pending img:not([src]){visibility:hidden}' +
      '.drehmer-pending__remove button{display:inline-flex;align-items:center;font-family:var(--font-body-family);font-size:1.3rem;font-weight:500;color:rgb(var(--color-foreground-secondary));text-underline-offset:unset;pointer-events:none}' +
      '.drehmer-checkout-wait{position:relative;color:transparent!important;pointer-events:none}' +
      '.drehmer-checkout-wait:after{content:"";position:absolute;left:50%;top:50%;width:18px;height:18px;margin:-9px 0 0 -9px;border:2px solid rgba(255,255,255,.45);border-top-color:#fff;border-radius:50%;animation:drehmer-spin .8s linear infinite}' +
      '@keyframes drehmer-spin{to{transform:rotate(360deg)}}' +
      '@media (prefers-reduced-motion:reduce){.drehmer-checkout-wait:after{animation-duration:2.4s}}' +
      'cart-drawer.drehmer-has-pending .drawer__inner-empty{display:none!important}';
    (document.head || document.documentElement).appendChild(st);
  })();
  function money(cents) {
    var v = cents / 100;
    return '$' + v.toLocaleString('en-US', { minimumFractionDigits: cents % 100 ? 2 : 0, maximumFractionDigits: 2 });
  }
  function renderKey(p) {
    if (!p.variant_id || !p.frame_variant_id) return '';
    return p.product_id + '-v' + p.variant_id + '-f' + p.frame_variant_id + (p.frame_style ? '-s' + p.frame_style : '');
  }
  function paintingName() {
    var el = document.querySelector('.drehmer__sticky-title strong') || document.querySelector('.drehmer__title');
    return el ? el.textContent.trim() : '';
  }
  function store(rec) { try { if (rec) sessionStorage.setItem(PENDING_KEY, JSON.stringify(rec)); else sessionStorage.removeItem(PENDING_KEY); } catch (e) {} }
  function pendingOpen(s, p) {
    var cart = document.querySelector('cart-drawer');
    var inner = cart && cart.querySelector('.drawer__inner');
    if (!cart || !inner || typeof cart.open !== 'function') return null;
    pendingClear();
    pendingDone = new Promise(function (res) { resolvePending = res; });
    var key = renderKey(p);
    var cents = s.totalCents > 0 ? s.totalCents * (s.quantity || 1) : 0;
    var fallbackImg = (document.querySelector('.drehmer__image-container img') || {}).currentSrc || '';
    /* the theme's own package-line markup (snippets/cart-drawer.liquid), so the real line replaces it without a visible
       change; no inputs inside, so the drawer's quantity handler never sees it */
    var esc = function (t) { return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
    var name = paintingName();
    var m = /([\d.]+)\s*×\s*([\d.]+)\s*in/.exec(String(s.sizeText || ''));
    var inches = m ? m[1] + "'' × " + m[2] + "''" : String(s.sizeText || '').split(' (')[0];
    /* the same words and pictures the cart line uses (pkg_line1, pkg_size_prefix, pkg_frame_name, frame_thumb_url) */
    var framed = s.format === 'framed', wrap = s.format === 'stretched';
    var kind = framed ? 'Framed · ' + frameText(s, null) : (wrap ? 'Gallery Wrap' : 'Unframed');
    var frameName = framed ? frameText(s, null) + ' frame' : (wrap ? 'Gallery wrap stretcher' : '');
    var sizePrefix = s.custom ? 'Custom size ' : 'Painting ';
    var swatch = document.querySelector('[data-drehmer-frame].is-selected img, [data-drehmer-frame][aria-pressed="true"] img');
    var frameThumb = wrap ? RENDER_BASE + '/frame-thumb/gallery-wrap.png' : (s.frame && s.frame.slug) ? RENDER_BASE + '/frame-thumb/' + s.frame.slug + '.png' : (swatch ? swatch.currentSrc || swatch.src : '');
    var price = cents ? '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '';
    var row = document.createElement('div');
    row.className = 'cart-item drehmer-pending';
    row.setAttribute('data-drehmer-pending', '');
    row.innerHTML =
      '<div class="cart-item__inner-top"><div class="cart-item__media"><img class="cart-item__image cart-item__image--package" alt="' + esc(name) + '" width="70" height="auto"></div>' +
      '<div class="cart-item__details"><div class="cart-item__details-wrapper"><div class="cart-item__info"><span class="cart-item__name">' + esc(name) + '</span>' +
      '<div class="cart-item__price-wrapper"><div class="cart-item__final-price">' + esc(price) + '</div></div></div>' +
      '<div class="cart-item__quantity-wrapper"><div class="quantity" aria-hidden="true"><button class="quantity__button" type="button" tabindex="-1" disabled>' + MINUS + '</button>' +
      '<span class="quantity__input" style="display:flex;align-items:center;justify-content:center">' + (s.quantity || 1) + '</span>' +
      '<button class="quantity__button" type="button" tabindex="-1" disabled>' + PLUS + '</button></div></div></div>' +
      '<div class="cart-item__bottom"><dl class="product-option__group">' +
      '<div class="product-option cart-item__package-sub cart-item__package-kind"><dt class="visually-hidden">Format</dt><dd>' + esc(kind) + '</dd></div>' +
      '<div class="product-option cart-item__package-sub"><dt class="visually-hidden">Size</dt><dd>' + sizePrefix + '<span class="cart-item__package-nowrap">' + esc(inches) + '</span></dd></div>' +
      (frameName ? '<div class="product-option cart-item__package-sub"><dt class="visually-hidden">Includes</dt><dd><button type="button" class="cart-item__package-toggle" aria-expanded="true" tabindex="-1">Includes 2 items' + CARET + '</button>' +
        '<ul class="cart-item__package-list"><li class="cart-item__package-part"><img class="cart-item__package-thumb" data-drehmer-paint-thumb alt="" width="40" height="40"><span class="cart-item__package-part-text"><span class="cart-item__package-part-name">' + esc(name) + '</span><span>' + sizePrefix + '<span class="cart-item__package-nowrap">' + esc(inches) + '</span></span></span></li>' +
        '<li class="cart-item__package-part"><img class="cart-item__package-thumb"' + (frameThumb ? ' src="' + esc(frameThumb) + '"' : '') + ' alt="" width="40" height="40"><span class="cart-item__package-part-text"><span class="cart-item__package-part-name">' + esc(frameName) + '</span><span>Made to fit <span class="cart-item__package-nowrap">' + esc(inches) + '</span></span></span></li></ul></dd></div>' : '') +
      '</dl><span class="drehmer-pending__remove"><button type="button" class="link" tabindex="-1">Remove</button></span></div>' +
      '<div class="cart-item__error"><small class="cart-item__error-text"></small></div>' +
      '<p class="drehmer-pending__status" role="alert"></p></div></div>';
    /* the framed picture the frame choice already loaded shows at once; otherwise the painting, until it arrives */
    var img = row.querySelector('.cart-item__image');
    if (fallbackImg) img.src = fallbackImg;
    var paintThumb = row.querySelector('[data-drehmer-paint-thumb]');
    if (paintThumb && fallbackImg) paintThumb.src = fallbackImg;
    var k = keyOf(p), framed = false;
    /* the first framed picture to arrive replaces the painting; after that only the cart line's own copy */
    var useThumb = function (t) {
      if (!t) return;
      var put = function () { if (row.isConnected && t.naturalWidth && (!framed || thumbs[k] === t)) { img.src = t.src; framed = true; } };
      if (t.complete) put(); else t.addEventListener('load', put);
    };
    /* where the theme puts its lines: newest first */
    var list = cart.querySelector('#CartDrawer-CartItems .drawer__cart-items-wrapper');
    if (!list) {
      var holder = cart.querySelector('#CartDrawer-CartItems');
      if (holder) { list = document.createElement('div'); list.className = 'drawer__cart-items-wrapper'; list.setAttribute('data-drehmer-made', ''); holder.appendChild(list); }
    }
    if (list) list.insertBefore(row, list.firstChild); else inner.appendChild(row);
    thumbWanted = { k: k, use: useThumb };
    useThumb(thumbs[k]);
    if (cache[k] && cache[k].result) thumbOf(k, cache[k].result);
    /* the header count, as the real cart will show it */
    var count = inner.querySelector('.drawer__count');
    if (count) {
      var n = parseInt((count.textContent.match(/\d+/) || ['0'])[0], 10) + (s.quantity || 1);
      count.setAttribute('data-drehmer-was', count.textContent);
      count.textContent = n + (n === 1 ? ' item' : ' items');
    }
    /* subtotal and checkout as if the line were already there */
    var total = inner.querySelector('.totals__subtotal-value');
    if (total && cents) {
      var t = total.textContent;
      var now = Math.round(parseFloat(t.replace(/[^0-9.]/g, '') || '0') * 100);
      total.setAttribute('data-drehmer-was', t);
      total.textContent = '$' + ((now + cents) / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + (/USD/.test(t) ? ' USD' : '');
    }
    inner.querySelectorAll('[name="checkout"]').forEach(function (b) {
      if (b.hasAttribute('disabled')) { b.removeAttribute('disabled'); b.setAttribute('data-drehmer-was-disabled', ''); }
      b.setAttribute('data-drehmer-held', '');
    });
    cart.classList.add('drehmer-has-pending');
    cart.classList.remove('is-empty');
    /* the theme hides checkout (inline display:none) while the cart total is 0 */
    cart.querySelectorAll('[data-cart-checkout-button]').forEach(function (w) { if (w.style.display === 'none') { w.style.display = 'block'; w.setAttribute('data-drehmer-was-hidden', ''); } });
    cart.querySelectorAll('cart-drawer-items.is-empty').forEach(function (el) { el.classList.remove('is-empty'); el.setAttribute('data-drehmer-was-empty', ''); });
    try { cart.open(document.querySelector('[data-drehmer-add-btn]')); } catch (e) { note('pending-open-fail', String(e && e.message || e)); }
    note('pending-open', key);
    return row;
  }
  /* Checkout clicked while the line is still being confirmed: hold the click, then click the real button. With the pair
     (painting + frame as two lines) already in the cart, checkout still waits for the package, so it always shows the
     same one-line setup; if the package takes longer than CHECKOUT_PAIR_HOLD_MS, the pair goes to checkout as it is. */
  var CHECKOUT_PAIR_HOLD_MS = 15000;
  var releaseCheckout = false;
  document.addEventListener('click', function (ev) {
    var b = ev.target && ev.target.closest && ev.target.closest('cart-drawer [data-drehmer-held][name="checkout"]');
    if (!b || !pendingDone || releaseCheckout) return;
    ev.preventDefault(); ev.stopImmediatePropagation();
    if (b.classList.contains('drehmer-checkout-wait')) return;
    b.classList.add('drehmer-checkout-wait');
    note('checkout-held', checkoutFree ? 'pair' : 'pending');
    var went = false;
    var timer = setTimeout(function () {
      if (went || !checkoutFree || swapping || !b.isConnected) return;
      went = true;
      note('checkout-pair');
      releaseCheckout = true;
      b.click();
      releaseCheckout = false;
    }, CHECKOUT_PAIR_HOLD_MS);
    pendingDone.then(function (ok) {
      clearTimeout(timer);
      if (went) return;
      went = true;
      var real = document.querySelector('cart-drawer [name="checkout"]:not([data-drehmer-held])');
      if (ok && real && !real.disabled) real.click();
      else b.classList.remove('drehmer-checkout-wait');
    });
  }, true);
  function pendingClear(ok) {
    checkoutFree = false; swapping = false; thumbWanted = null;
    var cart = document.querySelector('cart-drawer');
    document.querySelectorAll('[data-drehmer-pending]').forEach(function (r) { r.remove(); });
    if (resolvePending) { resolvePending(ok === true); resolvePending = null; pendingDone = null; }
    if (!cart) return;
    cart.classList.remove('drehmer-has-pending');
    cart.querySelectorAll('[data-drehmer-was]').forEach(function (t) { t.textContent = t.getAttribute('data-drehmer-was'); t.removeAttribute('data-drehmer-was'); });
    cart.querySelectorAll('[data-drehmer-held]').forEach(function (b) {
      b.classList.remove('drehmer-checkout-wait');
      if (b.hasAttribute('data-drehmer-was-disabled')) { b.setAttribute('disabled', ''); b.removeAttribute('data-drehmer-was-disabled'); }
      b.removeAttribute('data-drehmer-held');
    });
    cart.querySelectorAll('[data-drehmer-was-hidden]').forEach(function (w) { w.style.display = 'none'; w.removeAttribute('data-drehmer-was-hidden'); });
    cart.querySelectorAll('[data-drehmer-was-empty]').forEach(function (el) { el.classList.add('is-empty'); el.removeAttribute('data-drehmer-was-empty'); });
    cart.querySelectorAll('[data-drehmer-made]').forEach(function (el) { if (!el.children.length) el.remove(); });
    if (cart.querySelector('.drawer__inner-empty')) cart.classList.add('is-empty');
  }
  function pendingFail(text) {
    var row = document.querySelector('[data-drehmer-pending]');
    if (!row) return;
    row.classList.add('drehmer-pending--failed');
    var st = row.querySelector('.drehmer-pending__status');
    if (st) st.textContent = text;
  }

  /* an add the previous page didn't finish (the customer left before Shopify confirmed or before the swap) */
  (function resume() {
    var rec = null;
    try { rec = JSON.parse(sessionStorage.getItem(PENDING_KEY) || 'null'); } catch (e) {}
    if (!rec || !rec.p || Date.now() - (rec.at || 0) > 15 * 60 * 1000) { store(null); return; }
    note('resume', rec.phase + ' ' + rec.k);
    var post = function (url, body) {
      return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { if (!r.ok) throw new Error(url + ' http ' + r.status); return r.json(); });
    };
    var refresh = function () {
      if (/^\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
      var cart = document.querySelector('cart-drawer');
      fetch(location.pathname + '?sections=cart-drawer,cart-icon-bubble', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); }).then(function (sections) { if (cart && typeof cart.renderContents === 'function') { var o = cart.classList.contains('active'); cart.renderContents({ sections: sections }); if (!o) setTimeout(function () { cart.close && cart.close(); }, 0); } }).catch(function () {});
    };
    ensurePackage(Object.assign({}, rec.p, { prewarm: true }), PREWARM_TIMEOUT_MS).then(function (d) {
      if (!usable(d)) throw new Error('bad response');
      return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
        var key = String(d.key || rec.k);
        var items = c.items || [];
        var hasPackage = items.some(function (i) { return i.properties && (i.properties._package_key === key || i.properties._package_key === rec.k); });
        /* the pair by its line keys, or by its ID property when the page died before the keys were saved */
        var pair = (rec.keys || []).length ? items.filter(function (i) { return rec.keys.indexOf(i.key) >= 0; })
          : (rec.uid ? items.filter(function (i) { return i.properties && i.properties.ID === rec.uid; }) : []);
        if (!(rec.keys || []).length && pair.length) rec.keys = pair.map(function (i) { return i.key; });
        var addPackage = function (qty) {
          return post('/cart/add.js', { items: [{ id: d.variant_id, quantity: qty || rec.s.quantity || 1, properties: lineProperties(rec.s, d, rec.k) }] });
        };
        if (hasPackage) return null;
        if ((rec.phase === 'pending' || rec.phase === 'pair-adding') && !pair.length) return addPackage().then(refresh);
        if (pair.length && pair.length === rec.keys.length) {
          var updates = {}; rec.keys.forEach(function (k) { updates[k] = 0; });
          var qty = pair[pair.length - 1].quantity;
          return post('/cart/update.js', { updates: updates }).then(function () { return addPackage(qty); }).then(refresh);
        }
        /* mid-swap: the pair was taken out and the package never went in */
        if (rec.phase === 'swapping' && !pair.length) return addPackage().then(refresh);
        return null;   /* pair gone for another reason (checked out, removed): leave the cart alone */
      });
    }).then(function () { store(null); note('resume-done'); }, function (e) { note('resume-fail', String(e && e.message || e)); store(null); });
  })();

  var busy = false, bypass = false;
  function fallback(form, reason) {
    if (leaving) { note('left-before-confirm', reason); return; }   /* the next page finishes it */
    note('fallback', reason);
    busy = false;
    setBusy(false);
    store(null);
    /* the open cart keeps the line while the two-line add runs: the theme re-renders the cart when it lands; if it
       fails, the line itself says so (the theme's own message would sit behind the drawer) */
    if (document.querySelector('[data-drehmer-pending]') && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      var settled = false, offOk = null, offErr = null;
      var finish = function (ok) {
        if (settled) return; settled = true;
        if (offOk) offOk(); if (offErr) offErr(); if (typeof offMo === 'function') offMo();
        if (ok) { pendingClear(true); return; }
        pendingFail('We couldn\u2019t add this framed painting just now. Please try again in a moment.');
        setTimeout(function () { pendingClear(false); }, 8000);
      };
      offOk = subscribe(PUB_SUB_EVENTS.cartUpdate, function () { finish(true); });
      offErr = subscribe(PUB_SUB_EVENTS.cartError, function () { finish(false); });
      /* product-form.js shows some failures only as its own message (no event): treat that as the answer too */
      var pfEl = form.closest('product-form') || form;
      var mo = new MutationObserver(function () {
        var m = pfEl.querySelector('.product-form__error-message');
        if (m && m.textContent.trim() && !m.closest('[hidden]')) { mo.disconnect(); finish(false); }
      });
      mo.observe(pfEl, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['hidden'] });
      var offMo = function () { mo.disconnect(); };
      setTimeout(function () { if (document.querySelector('[data-drehmer-pending]')) finish(false); }, 15000);
    } else {
      pendingClear(false);
    }
    var s = readState();
    if (s && s.custom && !s.variantId) {
      note('no-fallback', 'custom size without helper variant');
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.close === 'function') drawer.close();
      cartNote(s);
      return;
    }
    bypass = true;
    try {
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    } finally {
      bypass = false;
    }
  }
  function priceCents(d) { return Math.round(parseFloat(String(d.price).replace(/[^0-9.]/g, '')) * 100); }

  /* The click always confirms with a normal (non-prewarm) call: it answers in ~0.5 s when the package
     exists and, for a new one, waits until its picture is ready (the service locks per selection, so it
     queues behind a prewarm still running). If that runs out of time, a package the prewarm already
     returned is still one line; with nothing at all, the old two-line flow takes over. */
  function waitMs() { return document.querySelector('[data-drehmer-pending]') ? OPEN_CART_WAIT_MS : CLICK_TIMEOUT_MS; }
  function packageForClick(p) {
    var k = keyOf(p);
    /* The package the frame choice already created is used as it is; one still being created is awaited. Neither
       waits for Shopify to process the package photo: the cart shows the service's render until it is ready. */
    var c0 = cache[k];
    if (c0 && c0.result && usable(c0.result)) { note('click-uses-prewarm', k); return Promise.resolve(c0.result); }
    if (c0 && c0.promise) {
      return withTimeout(c0.promise, waitMs()).then(function (d) {
        if (!usable(d)) throw new Error('bad response');
        return d;
      });
    }
    p = Object.assign({}, p, { prewarm: true });
    return withTimeout(callService(p, waitMs()), waitMs()).then(function (d) {
      if (!usable(d)) throw new Error('bad response');
      cache[k] = { result: d };
      thumbOf(k, d);
      return d;
    }, function (e) {
      var c = cache[k];
      if (c && c.result && usable(c.result)) {
        note('use-prewarm', String(e && e.message || e));
        return c.result;
      }
      throw e;
    });
  }

  /* ---------- no wait at all: the painting goes in as the theme's two-line pair at once, the package replaces it ----
     A package that already exists (or arrives within PACKAGE_QUICK_MS) is added directly. Otherwise the painting and its
     frame are added right away in one call, as the theme's grouped pair (same ID / _bundleVariants the two-line flow
     uses), so the cart is real at once; the open cart keeps showing the final line. When the package is ready the pair
     is swapped for it (remove the pair, add the package); a checkout tapped before that waits for it (up to
     CHECKOUT_PAIR_HOLD_MS). A page left mid-way is finished by the next one, and only while the pair is still in the cart. */
  var PACKAGE_QUICK_MS = 1500;
  var checkoutFree = false, swapping = false;
  function quick(promise, ms) {
    return new Promise(function (resolve) {
      var t = setTimeout(function () { resolve(null); }, ms);
      promise.then(function (d) { clearTimeout(t); resolve(d); }, function () { clearTimeout(t); resolve(null); });
    });
  }
  function postJSON(url, body) {
    return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw new Error((j && (j.description || j.message)) || ('http ' + r.status)); return j; }); });
  }
  function pairItems(form, s) {
    if (s.custom || !s.variantId) return null;
    var sel = document.querySelector('.bundle-variants');
    var fd = new FormData(form);
    var frameId = sel && sel.value, paintingId = fd.get('id');
    if (!frameId || !paintingId) return null;
    var uidEl = document.getElementById('unique-id'), bvEl = document.getElementById('variant-ids');
    var uid = (uidEl && uidEl.value) || Math.random().toString(36).slice(2, 8);
    var bv = (bvEl && bvEl.value) || '';
    var props = {};
    fd.forEach(function (v, name) { var m = /^properties\[(.+)\]$/.exec(name); if (m && v !== '') props[m[1]] = v; });
    props.ID = uid; props._bundleVariants = bv;
    var qty = Number(fd.get('quantity') || s.quantity || 1);
    /* a fresh ID for the next pair, as product-form.js does */
    if (uidEl) uidEl.value = Array.from(Array(6), function () { return Math.floor(Math.random() * 36).toString(36); }).join('');
    return [{ id: Number(frameId), quantity: qty, properties: { ID: uid, _bundleVariants: bv } }, { id: Number(paintingId), quantity: qty, properties: props }];
  }
  function sectionsToRender() {
    var cart = document.querySelector('cart-drawer');
    return cart && typeof cart.getSectionsToRender === 'function' ? cart.getSectionsToRender().map(function (x) { return x.id; }) : ['cart-drawer', 'cart-icon-bubble'];
  }
  /* the header's cart count, without touching the drawer */
  function refreshBubble() {
    fetch(window.location.pathname + '?sections=cart-icon-bubble', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).then(function (j) {
        var el = document.getElementById('cart-icon-bubble'), html = j && j['cart-icon-bubble'];
        if (!el || !html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html'), src = doc.querySelector('.shopify-section') || doc.body;
        el.innerHTML = src.innerHTML;
      }).catch(function () {});
  }
  function renderReal() {
    var cart = document.querySelector('cart-drawer');
    var done = function () { pendingClear(true); };
    if (!cart || typeof cart.renderContents !== 'function') { done(); return Promise.resolve(); }
    return fetch(window.location.pathname + '?sections=' + sectionsToRender().join(','), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).then(function (sections) { return cart.renderContents({ sections: sections }); }).then(done, done);
  }
  /* pair -> package; the cart is read first so nothing is ever added next to a pair that is gone (checked out, removed) */
  function swapPair(pf, d, s, k, keys, items) {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      var lines = (c.items || []).filter(function (i) { return keys.indexOf(i.key) >= 0; });
      if (lines.length !== keys.length) { note('swap-skip', lines.length); store(null); return renderReal(); }
      var qty = lines[lines.length - 1].quantity || 1;
      swapping = true;
      store({ phase: 'swapping', k: k, p: payloadOf(s, false), s: s, keys: keys, items: items, at: Date.now() });
      var updates = {}; keys.forEach(function (key) { updates[key] = 0; });
      return postJSON('/cart/update.js', { updates: updates }).then(function () {
        return cartAdd(pf, d, Object.assign({}, s, { quantity: qty }), k).then(function (out) {
          note('swapped', d.variant_id);
          store(null); swapping = false;
          var done = function () { pendingClear(true); };
          return Promise.resolve(showCart(pf, out, d.variant_id)).then(done, done);
        }, function (e) {
          /* the package could not go in: the pair comes back */
          note('swap-add-fail', String(e && e.message || e));
          return postJSON('/cart/add.js', { items: items.map(function (i) { return Object.assign({}, i, { quantity: qty }); }) }).then(function () { store(null); swapping = false; return renderReal(); });
        });
      });
    });
  }

  function run(pf, form, s) {
    var old = document.querySelector('[data-drehmer-cart-note]');
    if (old) old.remove();
    busy = true;
    setBusy(true);
    var p = payloadOf(s, false);
    var k = keyOf(p);
    var cartAttempted = false;
    note('click', k);
    /* the line is already in the open cart: the page's button goes back to normal (a second click stays ignored) */
    var opened = pendingOpen(s, p);
    if (opened) setBusy(false);
    store({ phase: 'pending', k: k, p: p, s: s, at: Date.now() });
    var pkg = packageForClick(p);
    function packagePath(d) {
      if (!usable(d)) throw new Error('bad response');
      var cents = priceCents(d);
      if (s.totalCents > 0 && Math.abs(cents - s.totalCents) > 1) {
        delete cache[k];
        throw new Error('price mismatch ' + cents + ' vs ' + s.totalCents);
      }
      cartAttempted = true;
      return cartAdd(pf, d, s, k).then(function (out) {
        note('added', { v: d.variant_id, price: d.price });
        busy = false;
        setBusy(false);
        store(null);
        var done = function () { pendingClear(true); };
        Promise.resolve(showCart(pf, out, d.variant_id)).then(done, done);
      }, function (e) {
        delete cache[k];
        throw e;
      });
    }
    var items = opened ? pairItems(form, s) : null;
    var flow = !items ? pkg.then(packagePath) : quick(pkg, PACKAGE_QUICK_MS).then(function (d) {
      if (d) return packagePath(d);
      /* the package isn't ready: the pair goes in now, the package replaces it when it is */
      cartAttempted = true;
      store({ phase: 'pair-adding', k: k, p: p, s: s, uid: items[0].properties.ID, items: items, at: Date.now() });
      return postJSON('/cart/add.js', { items: items }).then(function (res) {
        var keys = (res.items || []).map(function (i) { return i.key; });
        note('pair-added', keys.length);
        checkoutFree = true; busy = false;
        store({ phase: 'pair', k: k, p: p, s: s, keys: keys, uid: items[0].properties.ID, items: items, at: Date.now() });
        refreshBubble();
        return pkg.then(function (d2) {
          if (!usable(d2)) throw new Error('bad response');
          return swapPair(pf, d2, s, k, keys, items);
        }, function (e) {
          if (leaving) return;   /* the call died with the page: the next page swaps the pair */
          /* no package after all: the pair stays, the cart shows it as the theme does */
          note('package-never', String(e && e.message || e));
          store(null);
          return renderReal();
        });
      });
    });
    flow.catch(function (e) {
      if (cartAttempted) {
        if (leaving) return;   /* the next page checks the cart and finishes it if needed */
        busy = false;
        setBusy(false);
        swapping = false;
        note('cart-add-fail', String(e && e.message || e));
        store(null);
        pendingFail('We couldn’t confirm your cart. Please check it before trying again.');
        setTimeout(function () { pendingClear(false); }, 6000);
        return;
      }
      fallback(form, String(e && e.message || e));
    });
  }

  /* capture phase on document: runs before product-form.js's submit handler on the form */
  document.addEventListener('submit', function (ev) {
    if (bypass) return;
    var form = ev.target;
    if (!form || !form.closest) return;
    var pf = form.closest('product-form');
    if (!pf || !pf.closest('.drehmer')) return;
    var btn = pf.querySelector('[type="submit"]');
    if (busy || (btn && btn.getAttribute('aria-disabled') === 'true')) {
      /* a second click while an add is in flight: swallow it */
      if (busy) { ev.preventDefault(); ev.stopPropagation(); }
      return;
    }
    var s = readState();
    if (!needsPackage(s)) return;
    if (!serviceUrl()) { note('skip', 'no service url'); return; }
    ev.preventDefault();
    ev.stopPropagation();
    run(pf, form, s);
  }, true);
})();
